import React from 'react';

import { FullScreenAlert } from 'components/FullScreenAlert';
import { config } from 'environment/config';
import { useTranslation } from 'react-i18next';

export const UnderMaintenanceGuard = ({ children }: { children: unknown }) => {
  const { t } = useTranslation();

  return config.underMaintenance ? (
    <FullScreenAlert
      header={t('APP.UNDER_MAINTENANCE.TITLE')}
      body={t('APP.UNDER_MAINTENANCE.MESSAGE')}
      notice={t('APP.UNDER_MAINTENANCE.NOTICE')}
    />
  ) : (
    <>{children}</>
  );
};
